import { createDomain, type Scope, fork, sample } from 'effector';
import { debounce } from 'patronum';
import { signout } from '@features/common';
import { getObjectsWithSearch } from './api';
import type {
  GetObjectsWithSearchPayload,
  GetObjectsWithSearchResponse,
  Object,
  GetList,
} from './types';

export const ControlDomain = createDomain();

const scopes: { [key: string]: Scope } = {};

export const createScope = (name: string) => {
  if (scopes[name]) {
    return scopes[name];
  }

  scopes[name] = fork(ControlDomain);

  return scopes[name];
};

export const getList = ControlDomain.createEvent<GetList>();
export const search = ControlDomain.createEvent<GetList>();

export const $data = ControlDomain.createStore<Object[]>([]);
export const $pending = ControlDomain.createStore<boolean>(false);

const fxGetObjectsWithSearch = ControlDomain.createEffect<
  GetObjectsWithSearchPayload,
  GetObjectsWithSearchResponse,
  Error
>().use(getObjectsWithSearch);

/** Запрос данных */
sample({
  clock: [
    getList,
    debounce({
      source: search,
      timeout: 1000,
    }),
  ],
  fn: ({ fastFilters, search }) =>
    (fastFilters && Object.values(fastFilters).length > 0) || search
      ? { fast_filters: fastFilters, search: search || '' }
      : undefined,
  target: fxGetObjectsWithSearch,
});

$pending.on(fxGetObjectsWithSearch.pending, (_, pending) => pending).reset(signout);

$data
  .on(fxGetObjectsWithSearch.doneData, (_, { areaList }) =>
    Array.isArray(areaList)
      ? areaList.map((item) => ({
          id: item?.guid,
          label: item?.title ?? '',
        }))
      : []
  )
  .reset(signout);
